import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '@common/Header';
import PageLevelLoader from 'fk-cp-common-components/webComponents/V4/smartComponents/PageLevelLoader';
import { fetchRecentOrders } from 'fk-cp-common-components/actions/helpCentreActions';
import { getMyOrdersPagePayload } from 'fk-cp-common-components/actions/pageActionsV4';
import { formatMessage } from '@utils/i18n';
import ApiCallerInterface from '@utils/ApiCallerInterface';
var HelpRoot = function (_a) {
    var loading = _a.loading, fetchRecentOrders = _a.fetchRecentOrders, children = _a.children;
    useEffect(function () {
        var payload = getMyOrdersPagePayload({
            query: { source_page: 'HELP_CENTER' },
            paginationContext: { pageNumber: 1, paginatedFetch: false }
        });
        ApiCallerInterface('post', {}, fetchRecentOrders, payload);
    }, []);
    return loading ? (<React.Fragment>
			<Header>{formatMessage({ id: 'helpCentre' })}</Header>
			<PageLevelLoader />
		</React.Fragment>) : (children);
};
var mapStateToProps = function (state) { return ({
    loading: state.selfServe.helpCentre.loading
}); };
var mapDispatchToProps = {
    fetchRecentOrders: fetchRecentOrders
};
export default connect(mapStateToProps, mapDispatchToProps)(HelpRoot);
